import {svgIconWrapper} from '../svg-icon-wrapper';

import PlusRegular from './plus-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PlusRegular {...validProps} />;
}

SvgComponent.iconName = 'plusRegular';

/**
 * @deprecated This is a legacy icon
 */
export const PlusRegularIcon = svgIconWrapper(SvgComponent);
